/**
 * 视图：主页（home）
 * @url /home/index
 */
export default {
  /**
   * Favorite Shops 卡片
   */
  favoriteShop: {
    /**
     * 卡片标题
     */
    title: '收藏商城',
    /**
     * 图标标题（卡片右上角）
     */
    echartsTitle: '近30天指数',
    /**
     * 右侧ranking的标题
     */
    ranking: '指数排名',
    /**
     * 设置按钮
     */
    setting: '设置',
    settingTitle: '设置',
    selectErrorMsg: '请至少选择一个商城',
    noShop: '收藏夹中还没有商店',
    toAdd: '去添加...',
    ranking_: '排名',
  },
  /**
   * Top Clicks on Jessica's Secret 卡片
   */
  topClicks: {
    /**
     * 卡片标题
     */
    title: '杰西卡App热门点击',
    /**
     * 分类筛选按钮名称
     */
    filter: {
      title: '筛选条件',
      /**
       * 分类筛选的提示
       */
      category: '分类',
      /**
       * 品牌筛选的提示
       */
      brand: '品牌',
    },
    /**
     * 分类按钮
     */
    buttonGroup: {
      beauty: '美妆',
      bag: '箱包',
      accessories: '配饰',
      other: '烟酒食品',
    },
    /**
     * 导出：筛选条件
     */
    export: {
      button: '导出',
    },
    /**
     * 表格列
     */
    table: {
      no: 'NO.',
      image: '图片',
      product: '商品',
      brand: '品牌',
      category: '分类',
      percent: '比例',
      geo: '地区',
      shopAmt: '商城数量',
    },
  },
  /**
   * promos 卡片
   */
  promos: {
    /**
     * 卡片标题
     */
    title: '活动',
    /**
     * 右上角查看更多按钮
     */
    more: '查看更多',
    /**
     * tabs标题
     */
    tab: {
      shop: '活动商城',
      band: '活动品牌',
    },
    /**
     * shop tab的表格列
     */
    shopTable: {
      shops: '商城',
      promoAmt: '活动数量',
      promoBrandsAmt: '活动品牌数量',
    },
    /**
     * brand tab的表格列
     */
    bandTable: {
      brand: '品牌',
      promoAmt: '活动数量',
      promoBrandsAmt: '活动商城数量',
    },
  },
  /**
   * Jescard's  Brand Simple Index 卡片
   */
  brandSimpleIndex: {
    /**
     * 卡片标题
     */
    title: '杰西卡品牌指数',
    /**
     * 右上角查看去分析按钮
     */
    analyze: '详细分析',
    /**
     * table列
     */
    table: {
      no: 'NO.',
      logo: '商城标志',
      shop: '商城',
      opt: '指数（最优价）',
      ret: '指数（原价）',
    },
  },
  /**
   * Jescard  Simple Index 卡片
   */
  simpleIndex: {
    /**
     * 卡片标题
     */
    title: '杰西卡指数',
    /**
     * 右上角查看去分析按钮
     */
    analyze: '详细分析',
    /**
     * tabs标题
     */
    tab: {
      shop: '商城指数',
      top: '热门指数',
    },
    /**
     * shop tab的视图
     */
    shopTab: {
      /**
       * shop tab的表格列
       */
      table: {
        no: 'No.',
        logo: '商城标志',
        name: '商城名称',
        opt: '指数（最优价）',
        ret: '指数（原价）',
      },
    },
    topTab: {
      /**
       * top tab的视图 搜索条件
       */
      form: {
        time: '时间范围',
        timePlaceholder: '请选择时间范围',
        timeOptions: '近{0}天',
        timeRule: '事件范围为必选项',
        hotCategory: '热品分类',
        hotCategoryPlaceholder: '请选择时间范围',
        hotCategoryRule: '热榜分类为必选项',
        hotRange: '热品范围',
        hotRangePlaceholder: '请选择时间范围',
        hotRangeRule: '热品范围为必选项',
        button: '查询',
      },
      /**
       * 表格列
       */
      table: {
        no: 'No.',
        market: '国家',
        name: '商城名称',
        opt: '指数（最优价）',
        ret: '指数（原价）',
        sku: 'SKU',
      },
    },
  },
};
